import React from 'react';
import './Style/TermsAndConditions.css'; // Make sure to create or link your CSS file
import TopNavbar from './../home/TopNavbar';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <TopNavbar name="Terms & Conditions" />
      <div className="terms-card">
        <h1 className="terms-title">Terms & Conditions</h1>
        <p className="terms-updated">Last Updated: October 2026</p>

        <section className="terms-section">
          <h2>1. Agreement to Terms</h2>
          <p>
            By creating an account, downloading, accessing, or using the <strong>JEE Mock Test</strong> application, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not create an account or use our application.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. User Accounts & Verification</h2>
          <p>
            To access mock tests, track performance, and save your progress, you are required to register an account using your full name, target class, phone number, and a valid email address.
          </p>
          <ul>
            <li>You are responsible for maintaining the confidentiality of your account credentials and OTP verification codes.</li>
            <li>You agree to provide accurate and complete registration details.</li>
            <li>You are fully responsible for all activities that occur under your registered account.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. Intellectual Property Rights</h2>
          <p>
            All content available within the application, including mock test questions, answer keys, explanations, user interface design, logos, graphics, software code, and educational materials, is the intellectual property of <strong>JEE Mock Test</strong> / <strong>MY STUDY PLACE</strong> and is protected by applicable copyright laws.
          </p>
          <p>
            You are granted a limited, personal, non-exclusive, non-transferable license to access and use the app for individual educational and non-commercial test preparation purposes only. You may not scrape, copy, reproduce, distribute, or reverse engineer any part of this platform.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Prohibited User Conduct</h2>
          <p>When using JEE Mock Test, you strictly agree NOT to:</p>
          <ul>
            <li>Use automated bots, scripts, or scraping tools to extract questions or app data.</li>
            <li>Attempt to bypass authentication mechanisms, manipulate test scores, or compromise server security.</li>
            <li>Share your account credentials with multiple users for unauthorized commercial use.</li>
            <li>Engage in any activity that disrupts or interferes with the normal performance and servers of the application.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. Non-Affiliation & Government Disclaimer</h2>
          <p>
            <strong>JEE Mock Test</strong> is an independent educational platform operated by <strong>MY STUDY PLACE</strong>. It is not affiliated with, authorized by, endorsed by, or in any way officially connected with the National Testing Agency (NTA), the Indian Institutes of Technology (IITs), or any governmental examination authority.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Limitation of Liability & Service Availability</h2>
          <p>
            The app and its educational materials are provided on an "AS IS" and "AS AVAILABLE" basis. While we strive to maintain accurate mock test content and reliable uptime, we do not guarantee uninterrupted service or error-free content.
          </p>
          <p>
            <strong>JEE Mock Test</strong> shall not be liable for any indirect, incidental, or consequential damages resulting from app downtime, loss of test data, or examination performance outcomes.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Account Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account immediately, without prior notice, if you breach these Terms & Conditions or engage in fraudulent activities on the platform.
          </p>
          <p>
            You may also request voluntary account deletion at any time through the in-app settings or by contacting our support team.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms and Conditions at any time. Any changes will be posted on this page with an updated "Last Updated" revision date.
          </p>
        </section>

        <section className="terms-section contact-section">
          <h2>9. Contact Support</h2>
          <p>If you have any questions or concerns regarding these Terms and Conditions, please contact us at:</p>
          <div className="contact-details">
            <p><strong>Email:</strong> <a href="mailto:contact@mystudyplace.online">contact@mystudyplace.online</a></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;